import React from 'react';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Translate } from 'react-localize-redux';

type Props = {
  handleChange: (val: boolean) => void;
  val: boolean;
};

const CancelOrderControl = (props: Props) => {
  const { val, handleChange } = props;
  return (
    <FormControlLabel
      control={
        <Checkbox
          data-fd="refund_dialog_cancel_order"
          checked={val}
          color="secondary"
          onChange={(e) => {
            handleChange(e.target.checked);
          }}
          value="cancelOrder"
        />
      }
      label={<Translate id="Cancel-order" />}
    />
  );
};

export default CancelOrderControl;
